<div class="home-container">
  <div class="d-flex justify-content-center py-5">
    <div class="w-50 ps-5 pe-5">
      <h1 class="caption">
        Practice your math skills!
      </h1>
      <h4 style="color: #FFFF;">Get ready for Python or even Machine Learning as you get ready for the age of AI. From simple math to complex linear algebra to graph theory - let us see how much you score? Feel free to brag about your ELO rating on social media as you climb up the ratings in Math! Game ON!</h4>
    </div>
    <div class="w-50 pe-5" style="width: 90%;">
      <app-challenge [challenge]="mathProblem" (onNextQuestion)="onGenerateNewQuestion()"></app-challenge>
    </div>
  </div>
</div>

<div class="how-to-container">
  <div class="play-earn-container">
    <img [src]="playAndEarnImage" loading="lazy" class="mx-auto play-earn-img">
  </div>
  <div class="mx-auto px-5 pb-5 text-center">
    <h1 class="caption" style="color: #FFFF">
      Play and Earn Rewards!
    </h1>
    <h4 style="color: #FFFF;width: 50%;margin: auto;">Embark on an adventure filled with fun and excitement! Dive into gaming and unlock rewards along the way. Let the thrill of the game lead you to victory and rewards! Enjoy every moment and reap the benefits of your gaming journey.</h4>
  </div>
</div>
